import { Formik, Form } from 'formik';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './Register.module.css';
import { FormikTextField } from '../../components/form-components/common-components/text-field/FormikTextField';
import { useStore } from '../../hooks/useStore';
import KaldenLogo from '../../assets/kalden-logo.png';
import { RegisterSchema } from '../../schemas/RegisterSchema';
import {
  RegisterFormValues,
  RegisterResponse,
  registerInitialValues,
} from '../../models/user/UserModels';
import { RsValue } from '../../models/base/BaseModel';

export const Register = () => {
  const { userStore, uiStore } = useStore();
  const navigate = useNavigate();

  const handleSubmit = async (values: RegisterFormValues) => {
    try {
      uiStore.setLoading(true);
      const response: RsValue<RegisterResponse> = await userStore.register({
        username: values.name,
        email: values.email,
        password: values.password,
      });
      uiStore.setLoading(false);
      if (!response.error && response.value) {
        toast.success(response.message || 'Kayıt işlemi başarılı');
        navigate('/login');
      } else {
        toast.error(response.message || 'Kayıt işlemi başarısız');
      }
    } catch (error) {
      uiStore.setLoading(false);
      toast.error('Kayıt işlemi sırasında bir hata oluştu');
    }
  };

  return (
    <div className={styles.container}>
      <img src={KaldenLogo} alt="Kalden Logo" className={styles.logo} />
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Kayıt Ol</h1>
        <Formik
          initialValues={registerInitialValues}
          validationSchema={RegisterSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <FormikTextField
                name="name"
                label="Kullanıcı Adı"
                placeholder="Kullanıcı Adı Giriniz"
                disableUppercase
              />
              <FormikTextField
                name="email"
                label="Email"
                type="email"
                placeholder="Email adresinizi giriniz"
                disableUppercase
              />
              <FormikTextField
                name="password"
                label="Şifre"
                type="password"
                placeholder="Şifrenizi giriniz"
                disableUppercase
              />
              <FormikTextField
                name="confirmPassword"
                label="Şifre Tekrarı"
                type="password"
                placeholder="Şifrenizi tekrar giriniz"
                disableUppercase
              />
              <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
                {isSubmitting ? 'Kaydediliyor...' : 'Kayıt Ol'}
              </button>
              <div className={styles.loginLink}>
                Zaten hesabınız var mı? <Link to="/login">Giriş Yap</Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
